import { Dispatch } from 'redux';

import { ELearningKind } from '../actions/eLearning';
import * as Actions from '../actions/questionnaireList';
import { IUserAttr } from '../actions/session';
import { decodeHTMLEntities } from '../utils/Text';
import AbstractScenario from './AbstractScenario';

/** eラーニングTreeBlock情報取得シナリオ用パラメータ */
export interface IFetchQuestionnaireParam {
	careerID: string;
	classID: string;
	userAttr: IUserAttr;
}

/**
 * アンケート一覧シナリオファクトリ
 */
export default class QuestionnaireListScenarioFactory {
	/**
	 * アンケート一覧取得シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createFetchQuestionnaire(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<
			IFetchQuestionnaireParam
		> {
			protected process(arg: IFetchQuestionnaireParam) {
				const param = {
					accessType: 10,
					careerID: arg.careerID,
					classID: arg.classID,
					higherLevel: '1',
					lang: arg.userAttr.lang,
					lowerLevel: '1',
					userId: arg.userAttr.userId,
					viewMode: 0,
				};
				return this.read('el_el_ELearningTreeBlockModel', param).then(
					data => {
						const items = QuestionnaireListScenarioFactory.toQuestionnaireItem(
							data.treeList
						);
						this.dispatch(Actions.setItems({ items }));
					}
				);
			}
		}(dispatch, token);
		return scenario;
	}

	// QuestionnaireItem型変換
	protected static toQuestionnaireItem = (from: any[]) => {
		const to = [] as Actions.IQuestionnaire[];
		for (const f of from) {
			if (f.kind !== ELearningKind.ENQUETE) {
				continue;
			}
			const t: Actions.IQuestionnaire = {
				answerPeriod: decodeHTMLEntities(f.answerPeriod),
				enqueteType: f.enqueteType,
				expired: f.expired ? true : false,
				iconClass: f.iconClass,
				id: f.id,
				requiredFlg: f.requiredFlg ? true : false,
				text: f.text,
			};
			to.push(t);
			if (f.children) {
				QuestionnaireListScenarioFactory.toQuestionnaireItem(f.child);
				to.push(t);
			}
		}
		return to;
	};
}



// WEBPACK FOOTER //
// ./src/scenario/QuestionnaireListScenarioFactory.ts